import { useStores } from '../RootStore/RootStoreContext';

export const useExploreElementStore = () => {
  const { exploreElementStore } = useStores();
  return exploreElementStore;
};
